// src/components/EmptyState.jsx
// Message shown in a list that has no rows. It tells apart "nothing exists
// yet" from "the filters hide everything"; when filtered it offers a Clear
// filters button that does exactly what the list's Reset button does.
import Emo from './Emo';
export default function EmptyState({ icon, filtered, onClear, emptyText, filteredText, hint, clearLabel = 'Clear filters' }) {
  return (
    <div style={S.wrap}>
      {icon && <div style={S.icon}>{typeof icon === 'string' ? <Emo e={icon} /> : icon}</div>}
      <div>{filtered ? (filteredText || 'Nothing matches these filters.') : emptyText}</div>
      {hint && <div style={S.hint}>{hint}</div>}
      {filtered && onClear && (
        <button type="button" onClick={onClear} style={S.btn}>{clearLabel}</button>
      )}
    </div>
  );
}

const S = {
  wrap: { color: 'var(--t-90a4ae)', fontSize: 14, textAlign: 'center' },
  icon: { fontSize: 36, marginBottom: 10 },
  hint: { marginTop: 6, fontSize: 13 },
  btn: {
    marginTop: 14, padding: '8px 18px', background: 'var(--c-00897b)', color: 'var(--t-ffffff)', border: 'none',
    borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit'
  },
};
